import { render, staticRenderFns } from "./SnNewsDialog.vue?vue&type=template&id=9a5638ee&scoped=true"
import script from "./SnNewsDialog.vue?vue&type=script&lang=js"
export * from "./SnNewsDialog.vue?vue&type=script&lang=js"
import style0 from "./SnNewsDialog.vue?vue&type=style&index=0&id=9a5638ee&prod&lang=scss&scoped=true"
import style1 from "./SnNewsDialog.vue?vue&type=style&index=1&id=9a5638ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5638ee",
  null
  
)

export default component.exports